import PbAjax from "up-pbajax";
import publicpb from "../../global/publicpb";
import { encode, decode } from "./pb";
import global from "../../global/global";
import url from 'c-url';
const pbajax = new PbAjax();
let feature = url.query('feature') || 0;
// 创建service
const baseAjax = (service) => {
    let ua =
        `H5/h5 version/${global.getProjectVersion()} feature/${feature}` +
        window.navigator.userAgent;
    return (url, data, headers) => {
        return new Promise((resolve, reject) => {
            pbajax.do(
                {
                    service,
                    api: url,
                    header: {
                        UserAgent: ua,
                        ...headers,
                    },
                },
                encode(url, data),
                (res) => {
                    try {
                        let data = publicpb.Result.decode(res);
                        resolve(decode(url, data));
                    } catch (err) {
                        resolve(res);
                    }
                },
                (err) => {
                    reject(err);
                },
                (err) => {
                    reject(err);
                }
            );
        });
    };
};

export default baseAjax;



// WEBPACK FOOTER //
// ./js/service/api/service.js